<template>
  <div class="main">
    <header>
      <div class="logout" id="logout" v-show="showLogin" @mouseleave="hideLogin" @mouseenter="showLoginMark">
        <li v-show="!token" style="cursor: pointer" @click="toLoginPage">登录</li>
        <li v-show="token" style="cursor: pointer" @click="logout">退出登录</li>
      </div>
      <div class="top">
        <div class="login" style="border-radius: 0">
          <img @click="toHomePage" style="border-radius: 0; cursor: pointer;" src="../../../static/image/logo.png" alt="">
        </div>
        <div class="search">
          <label><img src="../../../static/image/search.jpg" alt=""></label>
          <input type="text" v-model="name" v-on:keyup.13="search">
          <label @click="search" style="line-height: 50px; background: #B0BECB; height: 48px; font-size: 16px; text-align: center; color: #fff">搜索</label>
        </div>
        <div class="login" @mouseleave="hideLogin" @mouseenter="showLoginMark">
          <img :src="avatarUrl + '?t=' + (new Date().getTime())" alt="">
          {{displayName}}
        </div>
      </div>
    </header>
    <ul class="ulType">
      <li id="oli" v-for="(item, index) in allCategories" style="cursor: pointer"
          :key="item.id"
          @click="loadProductGrid(index, item.action, item.id)"
          :class="{active:index==currentIndex}">
        {{item.name}}
      </li>
    </ul>

    <div>
      <swiper :options="swiperOption" class="swipe" v-if="allSwipeImage.length > 0" ref="mySwiper">
        <swiper-slide v-for="(item, index) in allSwipeImage" :key="item.id">
          <div class="swiper-zoom-container" >
            <img :src="item.imageUrl"/>
          </div>
        </swiper-slide>
        <div v-show="allSwipeImage.length > 1" class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="content">
      <ul>
        <li style="cursor: pointer" class="shadow" v-for="(item, index) in products" @click="toProductDetailsPage(item.id)" :key="index">
          <div class="img">
            <img :src="item.masterImageUrl"/>
          </div>
          <div class="main_content">
            <span class="title">{{item.name}}</span>
            <span class="subtitle">{{item.subtitle}}</span>
            <div class="liBottom">
              <i v-show="item.lowestAskPrice"><span v-show="item.lowestAskPrice">￥</span>{{item.lowestAskPrice}}</i>
              <i style="color:#ccc;" v-show="!(item.lowestAskPrice)">-</i>
              <em>{{item.soldNum}}人付款</em>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination v-show="products.length > 0"
        background layout="prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage1"
        :page-size="pageSize">
      </el-pagination>
    </div>
    <Footer v-show="products.length > 0"></Footer>
  </div>
</template>

<script>
	import Footer from '../common/footer';
	export default {
		inject: ['reload'],
		name: "productPage",
    components: {
			Footer
    },
		data() {
			return {
				name: "",
				showLogin: false,
				swiperOption: {
					loop: true,
					initialSlide: 0,
					autoplay: {
						delay: 3000, //3秒切换一次
						disableOnInteraction: false
					},
					pagination: {
						el: '.swiper-pagination',
						paginationType: 'bullets'
					},
				},
				allCategories: [],
				products: [],
				order: 'desc',
				sort: 'comprehensiveRanking',
				productObj: {},
				currentPage1: 1,
				pageNum: '',
				pageSize: 20,
				actionName: "",
        total: 0,
				allSwipeImage: [],
        currentIndex: 0,
				avatarUrl: "",
        displayName: localStorage.getItem('name'),
        token: localStorage.getItem('token'),
			}
		},
    beforeRouteEnter(to, from, next){
			next(vm => {
				if(from.name == 'loginPage'){
					vm.$router.go(0);
        }
      })
    },
		created() {
			this.pageNum = sessionStorage.getItem('pageNum') || 1;
			this.getData(this.pageNum, this.pageSize, this.order, this.sort);
			this.findAllNavigationCategory();
			this.getSwipe();

		},
    mounted(){
			let logout = document.getElementById('logout');
			logout.style.right = (document.body.clientWidth-1220)/2 + 'px';
			this.avatarUrl = localStorage.getItem('avatarUrl') || require('../../../static/image/header.jpg');
    },
		methods: {

			toLoginPage(){
				this.$router.push({
          name: "loginPage"
        })
      },

      logout(){
				this.avatarUrl = require('../../../static/image/header.jpg');
				this.token = !this.token;
				this.displayName = "";
				localStorage.clear();
        this.$router.push({
          name: "productPage"
        })
      },

			showLoginMark(){
				this.showLogin = true;
      },

      hideLogin(){
				this.showLogin = false;
      },

			initClear() {
				this.pageNum = 1;
				this.products = [];
			},
			getSwipe() {
				this.$store.dispatch('findAllSwipeImage', (Number(this.currentIndex) + 1)).then((res) => {
					if (res.data.code == 200) {
						this.allSwipeImage = res.data.data;
						console.log(this.allSwipeImage)
						if (this.allSwipeImage.length > 1) {
							this.swiperOption.loop = true;
						} else {
							this.swiperOption.loop = false;
						}
					} else {
						Toast({
							message: res.data.message,
							position: "middle",
							duration: 1500
						})
					}
				});
			},
			loadProductGrid(index, actionName, id) {
				this.allSwipeImage = [];
				this.initClear();
				this.currentIndex = index;
				this.getSwipe();
				sessionStorage.setItem('selectedCategoryName', actionName);
				sessionStorage.setItem('selectedCategoryIndex', index);
				this.actionName = actionName;
				this.getData(this.pageNum, this.pageSize, this.order, this.sort);
			},

			toProductDetailsPage(productId){
        this.$router.push({
          path: "/productDetails/" + productId
        })
      },

			handleSizeChange(val) {
				this.pageSize = val;
				this.getSwipe = [];
				this.products = [];
				this.getData(this.pageNum, this.pageSize, this.order, this.sort);
			},
			//当前页改变时触发的函数
			handleCurrentChange(val) {
				this.pageNum = val;
				sessionStorage.setItem('pageNum', val);
				this.getSwipe = [];
				this.products = [];
				this.getData(this.pageNum, this.pageSize, this.order, this.sort);
			},
			getData(pageNum, pageSize, order, sort) {
				let obj = {
					pageNum: pageNum,//this.pageNum,
					pageSize: pageSize,//this.pageSize,
					order: order,
					sort: sort,
					name: this.actionName
				};
				console.log(obj)
				this.$store.dispatch('productSearch', obj).then((res) => {
					this.productObj = res.data.data;
					this.total = this.productObj.pages * this.productObj.pageSize;
					this.currentPage1 = this.productObj.pageNum;
					this.products = res.data.data.list;
				})
			},

			//获取所有導航商品分类.
			findAllNavigationCategory() {
				this.$store.dispatch('findAllNavigationCategory').then((res) => {
					if (res.data.code == 200) {
						this.allCategories = res.data.data;
						this.currentIndex = sessionStorage.getItem('selectedCategoryIndex');
						if (this.currentIndex == null || this.currentIndex == 'undefined') {
							this.currentIndex = 0;
						}
						sessionStorage.removeItem('selectedCategoryIndex');
						//this.loadProductGrid(this.currentIndex, this.allCategories[this.currentIndex].action);
					} else {
						Toast({
							message: message.referenceError,
							position: "middle",
							duration: 1500,
						})
					}
				})
			},
      toHomePage(){
				this.$router.push({
          path: '/'
        })
      },
			search(){
				this.allSwipeImage = [];
				this.products = [];
				let obj = {
					pageNum: 1,
          pageSize: this.pageSize,
          order: this.order,
          sort: this.sort,
          name: this.name,
        };
				this.$store.dispatch('productSearchByText', obj).then((res) => {
					this.productObj = res.data.data;
					this.total = this.productObj.pages * this.productObj.pageSize;
					this.currentPage1 = this.productObj.pageNum;
					this.products = res.data.data.list;
        })
      }
		}
	}
</script>

<style scoped lang="scss">
  .active {
    color: #000;
    font-size: 17px;
    font-weight: 500;
  }
  .shadow:hover {

    -webkit-box-shadow: #ccc 0px 10px 10px;
    -moz-box-shadow: #ccc 0px 10px 10px;
    box-shadow: #ccc 0px 10px 10px;
    transition-property: all;
    transition-duration: 1s;


  }

  .main {
    width: 100%;

    header {
      width: 100%;
      background: #fff;
      height: 100px;
      position: relative;

      .logout{
        width: 100px;
        height: 50px;
        position: absolute;
        top: 70px;
        border: 1px solid #f2f2f2;
        border-radius: 6px;
        background: #fff;

        li{
          text-align: center;
          line-height: 50px;
        }
      }

      .top {
        height: 100px;
        width: 1220px;
        margin: 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .login{
          width: auto;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          img{
            display: block;
            width: 50px;
            height: auto;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        .search {
          width: 700px;
          height: 50px;
          background: #fff;
          border: 1px solid #B0BECB;
          display: flex;

          input {
            width: 600px;
            outline: none;
            border: none;
            height: 48px;
            font-size: 18px;
          }

          label {
            width: 50px;
            height: 50px;
            display: block;

            img {
              display: block;
              width: 30px;
              height: auto;
              margin: 10px 10px;
            }
          }
        }

        .allCategory {
          margin-top: 20px;
          float: right;
          margin-right: 560px;
        }
      }
    }

    .ulType {
      display: flex;
      overflow-x: scroll;
      webkit-overflow-scrolling: touch;
      justify-content: center;
      font-size: 15px;
      color: #999;
      width: 1220px;
      margin: 0 auto;

      li {
        list-style: none;
        padding: 10px 10px;
        height: 100%;
        text-align: center;
      }
    }
    .ulType::-webkit-scrollbar {display:none}

    .swipe {
      width: 976px;
      margin: 0 auto;
      //margin-top: 5/$sc+rem;

      .swiper-zoom-container {
        width: 100%;

        img {
          width: 976px;
          height: auto;
          display: block;
        }
      }
    }

    .content {
      width: 1220px;
      margin: 0 auto;

      ul {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 25%;
          padding-bottom: 15px;

          .img {
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 80%;
              width: auto;
              display: block;
            }
          }

          .main_content {
            width: 90%;
            margin-left: 5%;

            .title {
              font-weight: 500;
              overflow: hidden;
              height: 80px;
              display: flex;
              align-items: center;
              vertical-align: middle;
              text-align: center;
            }

            .subtitle {
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              overflow: hidden;
              -webkit-box-orient: vertical;
              text-align: center;
              color: #626262;
              //padding-bottom: 10px;
              margin-top: 10px;
              height: 40px;

            }

            .liBottom {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-around;
              flex-direction: row;
              width: 94%;
              margin-left: 3%;
              margin-top: 20px;

              i {
                display: block;
                font-style: normal;
                width: 50%;
                font-size: 20px;
                text-align: center;
              }

              em {
                display: block;
                font-style: normal;
                width: 50%;
                text-align: center;
                color: #ccc;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/product/productPage.vue